import React from "react";
import styled from "styled-components";
import cliff1 from "../images/cliff1.png";
import cliff2 from "../images/cliff2.png";

import { motion } from "framer-motion";

const Project5 = () => {
  return (
    <>
      <motion.div
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 1 }}
        exit={{ scaleY: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Main>
          <CaseStudy>
            <h2>CLiff Waters</h2>

            <p>
              A Landing page for a water company, built with Next.JS
              <br />
              <br />
              <a
                href="https://cliff-table-waters.netlify.app/"
                target="_blank"
                rel="noreferrer"
                alt="CLiff Waters"
              >
                View Site
              </a>
            </p>
          </CaseStudy>

          <Slider>
            <img src={cliff1} alt="cliff" />
            <img src={cliff2} alt="cliff" loading="lazy" />
          </Slider>
        </Main>
      </motion.div>
    </>
  );
};

export default Project5;

const Main = styled.main`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  position: relative;

  @media screen and (max-width: 760px) {
    margin: 4rem 0;
  }
`;

const CaseStudy = styled.div`
  flex: 1;
  padding: 2rem 0 0 0;

  h2 {
    text-align: center;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 3px;
    margin-bottom: 2rem;
  }

  p {
    font-size: 22px;
    padding: 0 2rem;
  }
`;

const Slider = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  display: flex;
  overflow-x: scroll;

  ::-webkit-scrollbar {
    display: none;
  }

  img {
    height: 350px;
    object-fit: contain;
    margin: 0 2rem;
  }

  @media screen and (max-width: 740px) {
    img {
      width: 95%;
      min-height: 250px;
      object-fit: cover;
    }
  }
`;
